// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-link-active[data-v-18c5d7ae] {\n  border-left-width: 1px;\n  border-top-width: 1px;\n  border-right-width: 1px;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.link[data-v-18c5d7ae] {\n  cursor: pointer;\n}\n.link h2[data-v-18c5d7ae] {\n  font-size: 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
